// dep
import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'

// app
import { UserFeatures } from '../constants/user-features'
import { environment as ENV } from '@environment'

/**
 * Read-only access to the dark launch flags (`dark_launch_users` /
 * `dark_launch_features`) of an arbitrary UID.
 */
@Injectable({
  providedIn: 'root'
})
export class DarkLaunchService {

  constructor(private http : HttpClient) {}

  /**
   * Fetches every dark launch flag for `uid`, both the global ones
   * (`generalFeatures`) and the per-user ones (`userFeatures`).
   */
  async getEnabledFeatures(uid : string) : Promise<UserFeatures> {
    return await this.http.get<UserFeatures>(`${ENV.apiUrl}/v2/users/${uid}/enabled-features`).toPromise()
  }

}
